import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const MarketingConsentModal = ({ showMarketingPreferencePopup, marketingConsentPrompt, callBack }) => {
  const { t } = useTranslation();
  return (
    <Modal show={showMarketingPreferencePopup} className="font-poppins profile-marketing-preference-modal" centered>
      <Modal.Body className="modalBody">
        <div className="marketing-consent-title my-2">
          {' '}
          {t('referralPromotionPreference.marketingConsentModal.contactPreferences')}
        </div>

        <p className="p-0 py-2 marketing-preference-prompt profile-marketing-preference-prompt">
          {marketingConsentPrompt}
        </p>
      </Modal.Body>
      <Modal.Footer className="p-0 mb-3">
        <div className="row w-100 px-5">
          <div className="col-6">
            <Button
              className="btn btn-primary w-100 marketing-consent-button"
              onClick={() => {
                callBack(true);
              }}
              title={t<string>('referralPromotionPreference.marketingConsentModal.button.yes')}
            >
              <span>{t('referralPromotionPreference.marketingConsentModal.button.yes')}</span>
            </Button>
          </div>
          <div className="col-6">
            <Button
              className="btn btn-secondary w-100 marketing-consent-button"
              onClick={() => {
                callBack(false);
              }}
              title={t<string>('referralPromotionPreference.marketingConsentModal.button.no')}
            >
              <span>{t('referralPromotionPreference.marketingConsentModal.button.no')}</span>
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default MarketingConsentModal;
